import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '../environment.service';
import { ErrorService } from '../errors/error.service';
@Injectable({
  providedIn: 'root'
})
export class ResignationService {
  private readonly RESIGNATION_SERVICE_URL = '/dpwsvc/v1/ext/code/';
  private readonly RESIGNATION_CODE: string = 'RESIGNATION_REASON';

  private _resReasons: Map<string, string> = new Map<string, string>();

  constructor(private http: HttpClient, private environmentService: EnvironmentService, private errorService: ErrorService) {
  }

  public getReasons() {
    this.http.get<Map<string, string>>(this.environmentService.getServer() +
                                      this.RESIGNATION_SERVICE_URL +
                                      this.RESIGNATION_CODE).subscribe(res => {
      this._resReasons = res;
    }, error => {
      this.errorService.processError(error);
    });
  }

  public get resReasons(): Map<string, string> {
    return this._resReasons;
  }

}
